import React from 'react';
import { Moon, Sun } from 'lucide-react';

const DarkModeToggle = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <button
      onClick={toggleDarkMode}
      className="p-2 rounded-full transition-colors"
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      data-tour="dark-mode-toggle"
    >
      {isDarkMode ? (
        <Sun size={20} className="text-white" />
      ) : (
        <Moon size={20} className="text-black" />
      )}
    </button>
  );
};

export default DarkModeToggle;